import { compose } from 'recompose';

import Modal from 'components/layout/Modal/styled';

const enhance = compose();

export default enhance(Modal);
